import { AfterViewInit, Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AppValidators } from '../util/validators';
import { Campo, Opcoe } from '../../../models/coleta';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ordernar } from 'src/app/services/ordenar';
import { at } from 'lodash';


export interface User {
  name: string;
}

@Component({
  selector: 'app-input-dropdown',
  templateUrl: './input-dropdown.component.html',
  styleUrls: ['./input-dropdown.component.scss']
})
export class InputDropdownComponent implements AfterViewInit {
  internalCampo: Campo = {};
  name = '';
  options: any;
  searchable: any;
 

  @Input()
  readOnly = false;

  @Input()
  requestFocus = false;

  @Input()
  currentFormControl: UntypedFormControl = new UntypedFormControl();

  @ViewChild('ngSelect') ngSelect!: NgSelectComponent;

  @Output() typeSelected = new EventEmitter<string>();

  @Input()
  set campo(campo: Campo) {
    this.name = campo.codigo || '';
    this.internalCampo = campo;

    campo.opcoes?.sort((a, b) => ordernar(a,b));

    this.options = campo.opcoes?.filter((opcao: Opcoe) => {
      if(opcao.ativo){
        return opcao.ativo === true;
      }
        return false;
    });
  }

  ngAfterViewInit(): void {

    this.checkSearchable();

    if (this.requestFocus) {
      setTimeout(() => {
        this.ngSelect.focus();
      });
    }
  }

  get campo(): Campo {
    return this.internalCampo;
  }

  isInvalid(): boolean {
    return !!this.currentFormControl?.invalid;
  }

  getErrorMessage(): string {
    return AppValidators.errorMessage(this.currentFormControl);
  }

  checkSearchable(): void {
    if (this.options.length >= 15) {
      this.searchable = true;
    } else {
      this.searchable = false;
    }
  }

  onTypeChange(selectedType: string){
    this.typeSelected.emit(selectedType);
  }
}